import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Star } from 'lucide-react';
export function Product() {
  const baseTomos = [{
    num: 'TOMO 1',
    title: 'Operación Suegra',
    desc: 'El punto de partida. Todo lo que necesitás saber para cocinar cuando hay presión: visitas, familia, la suegra. Recetas que impresionan sin que te lleve todo el día.'
  }, {
    num: 'TOMO 2',
    title: 'Los Infallables',
    desc: 'Las recetas que nunca fallan. Las que salen bien la primera vez, la segunda y la décima. El repertorio base de cualquier persona que cocina bien.'
  }, {
    num: 'TOMO 3',
    title: 'Ya fue, Cocinemos',
    desc: 'Para los días sin ganas, sin tiempo y sin inspiración. Platos rápidos, directos y ricos que sacás en 20 minutos con lo que tenés en la heladera.'
  }, {
    num: 'TOMO 4',
    title: 'Sin un Mango',
    desc: 'Cocina real con presupuesto real. Cómo estirar los ingredientes, gastar menos en el super y comer bien toda la semana sin que se note en el bolsillo.'
  }];
  const extraTomos = [{
    num: 'TOMO 5',
    title: 'El Toque',
    desc: 'Las técnicas y secretos que diferencian una comida buena de una que se recuerda. Marinadas, texturas, presentación y ese detalle que hace que todos pregunten cómo lo hiciste.',
    img: 'https://images.unsplash.com/photo-1532336414038-cf19250c5757?auto=format&fit=crop&w=400&q=70',
    alt: 'Especias y marinadas para darle el toque final a tus platos'
  }, {
    num: 'TOMO 6',
    title: 'El Remate',
    desc: 'Los postres y el cierre perfecto de cualquier comida. Desde lo más simple hasta lo que deja a todos sin palabras. Sin horno en la mayoría, con ingredientes de siempre.',
    img: 'https://images.unsplash.com/photo-1488477181946-6428a0291777?auto=format&fit=crop&w=400&q=70',
    alt: 'Postre casero como cierre perfecto de la comida'
  }];
  return <section className="py-10 md:py-20" data-id="element-200">
      <div className="max-w-5xl mx-auto px-4 md:px-6" data-id="element-201">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 md:mb-16" data-id="element-202">
          <span className="text-brand-gold font-bold tracking-widest uppercase text-xs md:text-sm mb-3 md:mb-4 block" data-id="element-203">
            El Sistema Completo
          </span>
          <h2 className="text-2xl md:text-5xl font-serif font-bold text-white mb-4 md:mb-6" data-id="element-204">
            Operación Suegra™ · Chef de Barrio
          </h2>
          <p className="text-sm md:text-xl text-gray-400 max-w-3xl mx-auto" data-id="element-205">
            No es un recetario. Es un sistema estructurado en tomos para que en
            un fin de semana entiendas cómo funciona la cocina, cocines tus
            primeros platos ricos y nunca más dependas de nadie.
          </p>
        </motion.div>

        <div className="mb-10 md:mb-16" data-id="element-206">
          <motion.h3 initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="text-xl md:text-2xl font-serif font-bold text-white mb-4 md:mb-8 flex items-center gap-2 md:gap-3" data-id="element-207">
            <BookOpen className="w-5 h-5 md:w-6 md:h-6 text-brand-gold" data-id="element-208" />{' '}
            EDICIÓN BASE — 4 Tomos Principales
          </motion.h3>
          <div className="grid md:grid-cols-2 gap-3 md:gap-6" data-id="element-209">
            {baseTomos.map((t, i) => <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} key={i} className="glass-panel p-5 md:p-8 rounded-xl relative overflow-hidden group" data-id="element-210">
                <div className="absolute top-0 left-0 w-1 h-full bg-brand-gold" data-id="element-211"></div>
                <span className="text-brand-gold text-xs md:text-sm font-bold tracking-widest mb-1.5 md:mb-2 block" data-id="element-212">
                  {t.num}
                </span>
                <h4 className="text-lg md:text-xl font-bold text-white mb-2 md:mb-3" data-id="element-213">
                  {t.title}
                </h4>
                <p className="text-sm md:text-base text-gray-400" data-id="element-214">{t.desc}</p>
              </motion.div>)}
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative" data-id="element-215">
          <div className="absolute inset-0 bg-gradient-to-b from-brand-gold/5 to-transparent rounded-2xl md:rounded-3xl -z-10" data-id="element-216"></div>
          <div className="p-5 md:p-10 border border-brand-gold/30 rounded-2xl md:rounded-3xl" data-id="element-217">
            <div className="mb-6 md:mb-8" data-id="element-218">
              <h3 className="text-xl md:text-2xl font-serif font-bold text-white mb-1 md:mb-2 flex items-center gap-2 md:gap-3" data-id="element-219">
                <Star className="w-5 h-5 md:w-6 md:h-6 text-brand-gold fill-brand-gold" data-id="element-220" />{' '}
                EDICIÓN COMPLETA — 4 Tomos + 2 Exclusivos
              </h3>
              <p className="text-sm md:text-base text-brand-gold" data-id="element-221">
                Incluye todo lo anterior más:
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-3 md:gap-5" data-id="element-222">
              {extraTomos.map((t, i) => <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.1
            }} key={i} className="bg-brand-panel rounded-xl border border-brand-gold/50 relative overflow-hidden flex items-stretch group" data-id="element-223">
                  <div className="absolute top-2 right-2 z-10 bg-brand-gold text-brand-dark text-[9px] md:text-[10px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wider" data-id="element-224">
                    Bono Exclusivo
                  </div>
                  {/* Representative image (optimizada + lazy) */}
                  <div className="relative w-24 sm:w-28 md:w-32 flex-shrink-0 overflow-hidden" data-id="element-225">
                    <img src={t.img} alt={t.alt} width={400} height={400} loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover transition-transform duration-300 group-hover:scale-105" data-id="element-226" />
                    <div className="absolute inset-0 bg-gradient-to-r from-transparent to-brand-panel/80" data-id="element-227"></div>
                  </div>
                  <div className="flex-1 p-4 md:p-5 min-w-0" data-id="element-228">
                    <span className="text-brand-gold text-[10px] md:text-xs font-bold tracking-widest mb-1 block" data-id="element-229">
                      {t.num}
                    </span>
                    <h4 className="text-base md:text-lg font-bold text-white mb-1 md:mb-1.5" data-id="element-230">
                      {t.title}
                    </h4>
                    <p className="text-xs md:text-sm text-gray-400 leading-snug" data-id="element-231">
                      {t.desc}
                    </p>
                  </div>
                </motion.div>)}
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}